import "./index.css";
import App from "./App";
import { HashRouter as Router } from "react-router-dom";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.js"

import Provider from './store';
import { createRoot } from "react-dom/client";
// import * as serviceWorker from './serviceWorker';

const root = createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <Provider>
    <Router>
      <App />
    </Router>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
